export default {
  setAdmins(state, value) {
    // eslint-disable-next-line no-param-reassign
    state.admins = value;
  },
  setAdminsErrors(state, value) {
    // eslint-disable-next-line no-param-reassign
    state.admins_errors = value;
  },
  setAdminsLoading(state, value) {
    // eslint-disable-next-line no-param-reassign
    state.admins_loading = value;
  },
  setCreateAdmin(state, value) {
    // eslint-disable-next-line no-param-reassign
    state.create_admin = value;
  },
  setCreateAdminErrors(state, value) {
    // eslint-disable-next-line no-param-reassign
    state.create_admin_errors = value;
  },
  setCreateAdminLoading(state, value) {
    // eslint-disable-next-line no-param-reassign
    state.create_admin_loading = value;
  },
};
